import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useMobileFormActions from '../hooks/useMobileFormActions';
import { useExtendedFormActions, mobileFormTypes } from '../hooks/useExtendedFormActions';

const MobileFormContext = createContext({ updateMobileFormField: () => {} });

const useContextValue = ({ idService, itemType = mobileFormTypes.service }) => {
  const summaryData = useMobileFormActions(idService);
  const { uploadEvidences } = useExtendedFormActions({ itemId: idService, itemType });

  const contextValue = useMemo(() => {
    return {
      updateMobileFormField: summaryData.updateMobileFormField,
      getEvidencesSignedPost: summaryData.getEvidencesSignedPost,
      getAttachmentsSignedPost: summaryData.getAttachmentsSignedPost,
      uploadEvidences,
      isUpdateAfterFinish: summaryData.isUpdateAfterFinish,
      idService,
    };
  }, [summaryData]);

  return contextValue;
};

export const MobileFormProvider = ({ children, idService, itemType }) => {
  const contextValue = useContextValue({ idService, itemType });

  return <MobileFormContext.Provider value={contextValue}>{children}</MobileFormContext.Provider>;
};

export const ExtendedFormProvider = ({ children, itemId, itemType }) => {
  const extendedFormActions = useExtendedFormActions({ itemId, itemType });

  const contextValue = useMemo(() => {
    return {
      getEvidencesSignedPost: extendedFormActions.getEvidencesSignedPost,
      getAttachmentsSignedPost: extendedFormActions.getAttachmentsSignedPost,
    };
  }, [extendedFormActions]);

  return <MobileFormContext.Provider value={contextValue}>{children}</MobileFormContext.Provider>;
};

MobileFormProvider.propTypes = {
  children: PropTypes.node,
  idService: PropTypes.string,
  itemType: PropTypes.number,
};

ExtendedFormProvider.propTypes = {
  children: PropTypes.node,
  itemId: PropTypes.string,
  itemType: PropTypes.number,
};

export default MobileFormContext;
